export var FIRST_ROW_LEVEL_CLASS_NAME = 'row-level-2';
export var FIRST_CONTENT_LEVEL_CLASS_NAME = 'content-level-2';
export var SECOND_CONTENT_LEVEL_CLASS_NAME = 'content-level-3';
export var ACTIVE_CLASS_NAME = 'active';
//# sourceMappingURL=Navigation.const.js.map